import { DepartamentoUsuarioReadingDtoProps } from "api/DTOs/DepartamentoUsuarioReadingDto"
import { UsuarioReadingFiltersDtoProps } from "api/DTOs/UsuarioReadingFiltersDto"

const TagsDepartamentos = ({
  departamentos,
}: UsuarioReadingFiltersDtoProps) => {
  return (
    <div className='tw-flex tw-flex-wrap tw-gap-3'>
      {departamentos?.map(
        (departamento: DepartamentoUsuarioReadingDtoProps) => (
          <span
            className='tw-py-2 tw-px-3 tw-bg-primary-10 tw-text-primary tw-border tw-border-primary tw-rounded tw-text-nowrap'
            key={Math.random()}
          >
            {departamento?.nombre}
            {departamento.esResponsable && <span> | R</span>}
          </span>
        )
      )}
    </div>
  )
}
export default TagsDepartamentos
